import { useContext } from 'react';
import { ScreenLabelsContext } from '../../../context/screen-labels/screen-labels';

/**
 * Resolves a drill-down dimension key to its display label, honouring the org's white-label terms
 * for location/supplier/subsidiary/project. Mirrors the Hotspot page's own dimensionLabel so every
 * drill surface names its dimensions the same way.
 */
export function useDrillDimensionLabel() {
  const screenLabelsContext = useContext(ScreenLabelsContext);
  return (dimension: string | null | undefined): string => {
    switch (dimension) {
      case 'category': return 'Category';
      case 'categoryGroup': return 'Category group';
      case 'scope': return 'Scope';
      case 'group': return 'Group';
      case 'good': return 'Good';
      case 'country': return 'Country';
      case 'location': return screenLabelsContext.getLabel('location', { plural: false, capitalize: 'first' });
      case 'supplier': return screenLabelsContext.getLabel('supplier', { plural: false, capitalize: 'first' });
      case 'subsidiary': return screenLabelsContext.getLabel('subsidiary', { plural: false, capitalize: 'first' });
      case 'project': return screenLabelsContext.getLabel('project', { plural: false, capitalize: 'first' });
      default: return dimension || '';
    }
  };
}
